"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _reactIntl = require("react-intl");

var _sanitize_utility = require("../../../../packages/common-utilities/src/sanitize_utility.js");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var notEmptyAndNotNull = function notEmptyAndNotNull(value) {
  return !(0, _ramda.isEmpty)(value) && !(0, _ramda.isNil)(value);
};

var Tooltip = function (_PureComponent) {
  _inherits(Tooltip, _PureComponent);

  function Tooltip() {
    _classCallCheck(this, Tooltip);

    return _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).apply(this, arguments));
  }

  _createClass(Tooltip, [{
    key: "renderTooltipText",
    value: function renderTooltipText() {
      var _props = this.props,
          text = _props.text,
          secondaryText = _props.secondaryText,
          messageKey = _props.messageKey;

      var tooltipText = [];
      var displayedText = text;

      if (messageKey) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: messageKey });
      }

      if ((0, _ramda.type)(text) === "Array" && (0, _ramda.length)(text) > 1) {
        displayedText = text.join("<br/><br/>");
      }

      if (notEmptyAndNotNull(displayedText)) {
        tooltipText.push(_react2.default.createElement("div", {
          key: "primary-disclosure-text",
          className: "fundAlertsubcont",
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(displayedText) }, id: "fundAlertsubcontText" }));
      }

      if (notEmptyAndNotNull(secondaryText)) {
        tooltipText.push(_react2.default.createElement(
          "div",
          { key: "secondary-disclosure-text" },
          _react2.default.createElement("br", null),
          _react2.default.createElement("div", { id: "global-tooltip-content", dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(secondaryText) } })
        ));
      }

      return tooltipText;
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          display = _props2.display,
          top = _props2.top,
          left = _props2.left,
          hideTooltip = _props2.hideTooltip,
          breakpoint = _props2.breakpoint,
          marginTop = _props2.marginTop;

      var tooltipStyling = {
        display: display,
        top: top,
        left: left,
        marginTop: (0, _ramda.isNil)(marginTop) ? 0 : marginTop,
        position: "absolute"
      };
      var mobileTooltipStyling = {};

      if (breakpoint < 4) {
        mobileTooltipStyling = (0, _ramda.omit)(["left"], (0, _ramda.merge)(tooltipStyling, { position: "fixed", top: "35%" }));
      }

      return _react2.default.createElement(
        "div",
        { "data-testid": "global-tooltip",
          className: "global-tooltip",
          style: tooltipStyling,
          role: "dialog", "aria-describedby": 'globalTooltip' },
        breakpoint < 4 && _react2.default.createElement("div", { className: "modal-backdrop", style: { display: display }, onClick: hideTooltip }),
        _react2.default.createElement(
          "div",
          { id: "globalTooltip", tabIndex: "-1", style: mobileTooltipStyling, className: "headerTooltip" },
          _react2.default.createElement(
            "div",
            { className: "headerTipContent withCloseButton" },
            this.renderTooltipText()
          ),
          _react2.default.createElement(
            "button",
            { id: "closeTip-global-tooltip",
              "data-testid": "close-tooltip",
              "aria-label": "Close",
              className: "closeTip",
              onClick: hideTooltip },
            _react2.default.createElement("span", { className: "crossImage" })
          )
        )
      );
    }
  }]);

  return Tooltip;
}(_react.PureComponent);

exports.default = Tooltip;